module.exports = __webpack_public_path__ + "static/media/male_adult.67f2d473.svg";